const { API_URL } = window
const API_VERSION_V1 = 'v1'
const API_URL_V1 = `${API_URL}/${API_VERSION_V1}`

const endpoints = {
  login: `${API_URL_V1}/auth/createSession`,
  sessionRefresh: `${API_URL_V1}/auth/refreshSession`,
  logout: `${API_URL_V1}/auth/deleteSession`,
  getMe: `${API_URL_V1}/billing/getMe`,
  getPartnersIncomes: `${API_URL_V1}/billing/getPartnersIncomes`,
  getAllPeriods: `${API_URL_V1}/billing/getAllPeriods`,
  searchUsers: `${API_URL_V1}/billing/searchUsers`,
  getAllGoalsTypes: `${API_URL_V1}/billing/getAllGoalsTypes`,
  addPartnerToFavoriteIncome: `${API_URL_V1}/billing/addPartnerToFavoriteIncome`,
  removePartnerFromFavoriteIncome: `${API_URL_V1}/billing/removePartnerFromFavoriteIncome`,
  getPartnerIncomeDetails: `${API_URL_V1}/billing/getPartnerIncomeDetails`,
  getAllJournalContacts: `${API_URL_V1}/journal/getAllJournalContacts`,
  getJournalContact: `${API_URL_V1}/journal/getJournalContact`,
  createJournalContact: `${API_URL_V1}/journal/createJournalContact`,
  toggleJournalContactsFavorite: `${API_URL_V1}/journal/toggleJournalContactsFavorite`,
  toggleJournalContactsArchive: `${API_URL_V1}/journal/toggleJournalContactsArchive`,
  getUserRemittances: `${API_URL_V1}/billing/getRemittance`,
  createRemittance: `${API_URL_V1}/billing/createRemittance`,
  toggleJournalContactsVisited: `${API_URL_V1}/journal/toggleJournalContactsVisited`,
  getTotalJournalContacts: `${API_URL_V1}/journal/getTotalJournalContacts`,
  getTotalJournalTasks: `${API_URL_V1}/journal/getTotalJournalTasks`,
  createJournalTag: `${API_URL_V1}/journal/createJournalTag`,
  removeJournalTag: `${API_URL_V1}/journal/removeJournalTag`,
  updateJournalContact: `${API_URL_V1}/journal/updateJournalContact`,
  getAllJournalActionTypes: `${API_URL_V1}/journal/getAllJournalActionTypes`,
  createJournalAction: `${API_URL_V1}/journal/createJournalAction`,
  createJournalTask: `${API_URL_V1}/journal/createJournalTask`,
  toggleJournalTaskComplete: `${API_URL_V1}/journal/toggleJournalTaskComplete`,
  getAllJournalTasks: `${API_URL_V1}/journal/getAllJournalTasks`,
  getLocationCities: `${API_URL_V1}/billing/getLocationCities`,
  getLocationCountries: `${API_URL_V1}/billing/getLocationCountries`,
  getCurrentVerification: `${API_URL_V1}/billing/getCurrentVerification`,
  createVerification: `${API_URL_V1}/billing/createVerification`,
  fireVerificationEvent: `${API_URL_V1}/billing/fireVerificationEvent`,
  getVerificationRequirements: `${API_URL_V1}/billing/getVerificationRequirements`,
  getAccountBalance: `${API_URL_V1}/billing/getAccountBalance`,
  attachVerificationFile: `${API_URL_V1}/billing/attachVerificationFile`,
  getAllEvents: `${API_URL_V1}/billing/getAllEvents`,
  createWithdrawal: `${API_URL_V1}/billing/createWithdrawal`,
  getCommissions: `${API_URL_V1}/billing/getCommissions`,
  createGoalByIncome: `${API_URL_V1}/billing/createGoalByIncome`,
  createGoalByQualification: `${API_URL_V1}/billing/createGoalByQualification`,
  getCurrentGoal: `${API_URL_V1}/billing/getCurrentGoal`,
  getReferralLinks: `${API_URL_V1}/tools/getReferralLinks`,
  getPosts: `${API_URL_V1}/tools/getPosts`,
  getAncestors: `${API_URL_V1}/billing/getAncestors`,
  getUserBranch: `${API_URL_V1}/billing/getAncestorsByUser`,
  getIncomeDetailsByCurrentPeriod: `${API_URL_V1}/billing/getIncomeDetailsByCurrentPeriod`,
  getAllProducts: `${API_URL_V1}/billing/getAllProducts`,
  giveProduct: `${API_URL_V1}/journal/giveProduct`,
  getUserNotices: `${API_URL_V1}/notice/getUserNotices`,
  getGoalReport: `${API_URL_V1}/billing/getGoalReport`,
  readNotice: `${API_URL_V1}/notice/readNotice`,
  getWithdrawal: `${API_URL_V1}/billing/getWithdrawal`,
  getPossibleQualificationAndRequirements: `${API_URL_V1}/billing/getPossibleQualificationAndRequirements`,
  updateOwner: `${API_URL_V1}/journal/updateOwner`,
  getPhotos: `${API_URL_V1}/tools/getPhotos`,
  getPresentations: `${API_URL_V1}/tools/getPresentations`,
  getVideoLinks: `${API_URL_V1}/tools/getVideoLinks`,
  getSalesReport: `${API_URL_V1}/billing/getSalesReport`,
  getProductCategories: `${API_URL_V1}/billing/getProductCategories`,
  getSalesReportDetail: `${API_URL_V1}/billing/getSalesReportDetail`,
  createCard: `${API_URL_V1}/billing/createCard`,
  activateCard: `${API_URL_V1}/billing/activateCard`,
  getCards: `${API_URL_V1}/billing/getCards`,
  deleteCard: `${API_URL_V1}/billing/deleteCard`,
  getDiagnosticsReport: `${API_URL_V1}/billing/getDiagnosticsReport`,
  getDiagnosticsLinks: `${API_URL_V1}/tools/getDiagnosticsLinks`,
}

export default endpoints
